import CustomVectorLayer from './CustomVectorLayer';
import { TrackEntity } from './TrackEntity';
import { Options } from 'ol/layer/BaseVector';
import { TrackVectorLayerType } from './TrackVectorLayerType';
import _, { zip } from 'lodash';
import VectorSource from 'ol/source/Vector';

export default class TrackVectorLayer<VectorSourceType extends VectorSource<any>> extends CustomVectorLayer<VectorSourceType> {
    type: TrackVectorLayerType
    track: TrackEntity
    zIndexWithinTrack: number
    constructor(track: TrackEntity, type: TrackVectorLayerType, zIndexWithinTrack: number, options: Options<VectorSourceType>) {
        super(_.extend({zIndex: track.zIndexForLayer(zIndexWithinTrack)}, options))
        this.zIndexWithinTrack = zIndexWithinTrack
        this.track = track
        track.layers.push(this)
        this.type = type
    }
}